/// <amd-module name="Feed/Legacy/Protocols/Ivy/IvyOverviewAttributesPanel" />
import * as React from "react";

import {
    IvyXmlConfiguration,
    IvyXmlDescription,
    IvyXmlInfo,
    IvyXmlModule,
    IvyXmlRef
} from "Feed/Common/Protocols/Ivy/Contracts/Ivy";
import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { PackageDependencies } from "Feed/Legacy/Protocols/Components/PackageDependencies";
import { IProjectAttribute } from "Feed/Legacy/Protocols/Components/PackageDevelopment";
import { PackageProvenance } from "Feed/Legacy/Protocols/Components/PackageProvenance";
import { PackageStats } from "Feed/Legacy/Protocols/Components/PackageStats";
import { IvyCiConstants } from "Feed/Legacy/Protocols/Ivy/Constants/IvyConstants";
import { IvyDevelopment } from "Feed/Legacy/Protocols/Ivy/IvyDevelopment";
import { IvyPackagePeople } from "Feed/Legacy/Protocols/Ivy/IvyPackagePeople";

export class IvyOverviewAttributesPanel extends React.PureComponent<IPackageDetailsProps> {
    public render(): JSX.Element {
        const ivyModule: IvyXmlModule =
            this.props.packageVersion.protocolMetadata && this.props.packageVersion.protocolMetadata.data
                ? (this.props.packageVersion.protocolMetadata.data as IvyXmlModule)
                : null;
        const info: IvyXmlInfo = ivyModule && ivyModule.info;
        return (
            <div className="ivy-overview-attributes-panel package-overview-attributes-panel">
                <PackageProvenance
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageId={this.props.packageSummary.id}
                    versionId={this.props.packageVersion.id}
                    publishDate={new Date(this.props.packageVersion.publishDate)}
                    isProvenanceEnabled={this.props.isProvenanceEnabled}
                    isProvenanceSupported={false}
                />
                <IvyPackagePeople pageContext={this.props.pageContext} authors={info ? info.ivyauthor : null} />
                <IvyDevelopment
                    pageContext={this.props.pageContext}
                    feedId={this.props.feed.id}
                    normalizedName={this.props.packageSummary.normalizedName}
                    normalizedVersion={this.props.packageVersion.normalizedVersion}
                    projectConfigurations={this._getProjectConfigurations(ivyModule)}
                    projectAttributes={this._getProjectAttributes(info)}
                />
                {this.props.isMetricsEnabled && (
                    <PackageStats
                        packageVersionMetrics={this.props.packageVersionMetrics}
                        packageMetrics={this.props.packageMetrics}
                        isMetricsLoading={this.props.isMetricsLoading}
                        feed={this.props.feed}
                    />
                )}
                <PackageDependencies
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                    dependencyHelperCallback={null}
                    isSmartDependenciesEnabled={this.props.isSmartDependenciesEnabled}
                />
            </div>
        );
    }

    private _getProjectAttributes(info: IvyXmlInfo): IProjectAttribute[] {
        if (info) {
            const items: IProjectAttribute[] = [];

            items.push({
                iconClass: "bowtie-icon bowtie-plug-connected",
                text: "index.json",
                url: "",
                onClickCiFeature: IvyCiConstants.ModuleIndexAnchorClicked
            } as IProjectAttribute);

            if (info.organisation && info.description) {
                info.description.map((d: IvyXmlDescription) => {
                    if (d.homepage && d.homepage.length > 0) {
                        items.push({
                            iconClass: "bowtie-icon bowtie-globe",
                            text: info.organisation,
                            url: d.homepage,
                            onClickCiFeature: IvyCiConstants.OrganizationLinkClicked
                        } as IProjectAttribute);
                    }
                });
            }

            if (info.license && info.license.length > 0) {
                info.license.map((license: IvyXmlRef) => {
                    items.push({
                        iconClass: "bowtie-icon bowtie-script",
                        text: license.name,
                        url: license.url,
                        onClickCiFeature: IvyCiConstants.LicenseLinkClicked
                    } as IProjectAttribute);
                });
            }

            if (items.length > 0) {
                return items;
            }
        }

        return null;
    }

    private _getProjectConfigurations(ivyModule: IvyXmlModule): IProjectAttribute[] {
        if (ivyModule) {
            const items: IProjectAttribute[] = [];

            if (ivyModule.configurations && ivyModule.configurations.conf && ivyModule.configurations.conf.length > 0) {
                ivyModule.configurations.conf.map((conf: IvyXmlConfiguration) => {
                    items.push({
                        text: conf.name
                    } as IProjectAttribute);
                });
            }

            if (items.length > 0) {
                return items;
            }
        }

        return null;
    }
}
